// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YqGaof {
  border-radius: 4px;
  border: 1px solid var(--stroke-neutral-subtle);
  padding: var(--spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
}

.IUqAhL {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.v6EI2p {
  color: var(--text-neutral-dark);
  line-height: var(--line-height-auto);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  margin: 0;
}

.LnrdS_ {
  padding: 0;
}

.JJr4ZR {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ujB1OQ {
  color: var(--text-neutral-dark);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  margin: 0;
}

.nwQ20K {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  min-width: 0;
  width: 100%;
}

.ZSWyno {
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: 4px;
  padding: 14px 8px;
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: 20px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
}

.o7d_oz {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  justify-content: center;
  flex-shrink: 0;
}

.eaEXZD {
  width: 16px;
  height: 16px;
}

@media (max-width: 768px) {
  .YqGaof {
    padding: 16px;
  }

  .nwQ20K {
    flex-direction: column;
    align-items: stretch;
  }

  .ZSWyno {
    white-space: normal;
    word-break: break-all;
    text-overflow: clip;
    overflow: visible;
  }

  .v6EI2p {
    font-size: 16px;
  }

  .ujB1OQ {
    font-size: 13px;
  }

  .o7d_oz {
    width: 100%;
    min-width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorPaymentBankSlipPage/components/EmissorPaymentBankSlipCode/EmissorPaymentBankSlipCode.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".container {\n  border-radius: 4px;\n  border: 1px solid var(--stroke-neutral-subtle);\n  padding: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n}\n\n.titleContainer {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.title {\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-auto);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  margin: 0;\n}\n\n.downloadButton {\n  padding: 0;\n}\n\n.codeSection {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.description {\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  margin: 0;\n}\n\n.codeContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: center;\n  min-width: 0;\n  width: 100%;\n}\n\n.codeText {\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: 4px;\n  padding: 14px 8px;\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: 20px;\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.copyButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 200px;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.copyIcon {\n  width: 16px;\n  height: 16px;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n\n  .codeContainer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .codeText {\n    white-space: normal;\n    word-break: break-all;\n    text-overflow: clip;\n    overflow: visible;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .description {\n    font-size: 13px;\n  }\n\n  .copyButton {\n    width: 100%;\n    min-width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `YqGaof`,
	"titleContainer": `IUqAhL`,
	"title": `v6EI2p`,
	"downloadButton": `LnrdS_`,
	"codeSection": `JJr4ZR`,
	"description": `ujB1OQ`,
	"codeContainer": `nwQ20K`,
	"codeText": `ZSWyno`,
	"copyButton": `o7d_oz`,
	"copyIcon": `eaEXZD`
};
module.exports = ___CSS_LOADER_EXPORT___;
